type ContextValue = string | number | boolean | undefined;
type ContextProps = Record<string, ContextValue>;

export const TOKEN_LENGTH_WARNING_CHARS = 4000;

const SESSION_TAIL_LENGTH = 6;

export interface ConnectionInfo {
  effectiveType?: string;
  rtt?: number;
}

export interface HardwareInfo {
  deviceMemory?: number;
  hardwareConcurrency?: number;
}

export const describeToken = (token: string | null | undefined): ContextProps =>
  token
    ? {
        token_length: token.length,
        token_oversized: token.length > TOKEN_LENGTH_WARNING_CHARS,
      }
    : { token_length: 0 };

export const describeConnection = (
  connection?: ConnectionInfo | null,
): ContextProps =>
  connection
    ? {
        net_type: connection.effectiveType,
        net_rtt_ms: connection.rtt,
      }
    : {};

export const readConnection = (): ConnectionInfo | undefined =>
  (navigator as Navigator & { connection?: ConnectionInfo }).connection;

export const tailOf = (value: string | null | undefined): string | undefined =>
  value ? value.slice(-SESSION_TAIL_LENGTH) : undefined;

export const isTabVisible = (
  doc: { visibilityState: string } = document,
): boolean => doc.visibilityState === "visible";

export const estimateHeaderBytes = (
  parts: Array<string | null | undefined>,
): number => parts.reduce<number>((total, part) => total + (part ? part.length : 0), 0);

export const describeHardware = (info?: HardwareInfo): ContextProps => {
  const source = info ?? (navigator as Navigator & HardwareInfo);
  return {
    device_memory_gb: source.deviceMemory,
    cpu_cores: source.hardwareConcurrency,
  };
};

export const definedOnly = (props: ContextProps): Record<string, string | number | boolean> =>
  Object.fromEntries(
    Object.entries(props).filter(([, value]) => value !== undefined),
  ) as Record<string, string | number | boolean>;
